import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { MediumTransformationListComponent } from '../../../../../pages/network/medium-transformation-list/medium-transformation-list.component';

export const mediumTransformationList: Route = {
  path: 'mediumTransformationList',
  title: 'nav.network.mediumTransformations',
  data: {
    breadcrumb: 'nav.network.mediumTransformations',
    icon: SbIcons.expand,
    id: RoutingID.mediumTransformationList,
  },
  children: [
    {
      path: '',
      component: MediumTransformationListComponent,
      data: {
        breadcrumb: '',
      },
    },
  ],
};
